module.exports = __webpack_public_path__ + "static/media/client-portal.0a04f67d.svg";